import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { MedicalRequest } from 'src/app/_models/PSP/medical-requests.model';
import { Pharmacy } from 'src/app/_models/PSP/pharmacy.model';
import { MedicationRequestService } from 'src/app/_services/PSP/medication-request.service';
import { PharmaciesService } from 'src/app/_services/PSP/pharmacies.service';
import { PatientSubscription } from 'src/app/_models/patient.model';
import { PatientService } from 'src/app/_services/patient.service';

@Component({
  selector: 'app-select-pharamcy',
  templateUrl: './select-pharamcy.component.html',
  styleUrls: ['./select-pharamcy.component.scss'],
})
export class SelectPharamcyComponent implements OnInit {
  request: MedicalRequest;
  pharmacyList: Pharmacy[] = [];
  selectedPharmacy;
  searchPharmacyStep = 1;
  selectedSubscription: PatientSubscription;
  isInsulinProgram = false;

  constructor(
    private medicalRequestService: MedicationRequestService,
    private toastr: ToastrService,
    private pharmacyService: PharmaciesService,
    private patientService: PatientService,
    private medicationService: MedicationRequestService,
  ) { }

  ngOnInit(): void {
    this.selectedSubscription = this.patientService.selectedSubscription;
    this.isInsulinProgram = this.medicationService.isInsulinRequest(this.selectedSubscription?.program?.name);

    this.medicalRequestService
      .getSelectedRequest()
      .subscribe((request: any) => {
        this.request = request;

        if (!request) {
          //
          window.history.back();

          // document.referrer;
          // showNotification('danger', 'Please select correct request', this.toastr)
          // this.router.navigate(['/psp/medication/home-delivery']);
        }
        this.pharmacyService
          .getPspPharmaciesByAreaId(this.request.patientAddressData.area.id, this.isInsulinProgram)
          .subscribe((res) => {
            this.pharmacyList = res?.data?.pharmacies;
          });
      });
  }

  searchPharmacy(searchString): void {
    if (searchString.length > 0) {
      this.pharmacyService
        .searchPspPharmacies(this.request.patientAddressData.area.id, searchString, this.isInsulinProgram)
        .subscribe((res) => {
          this.pharmacyList = res?.data?.pharmacies;
        });
    }
  }

  onSelectPharmacy(pharmacy): void {
    this.selectedPharmacy = pharmacy;
    this.searchPharmacyStep = 2;
  }

  copyToClipboard(str): void {
    navigator.clipboard.writeText(str);
    showNotification('default', 'Copied to clipboard', this.toastr);
  }

  confirmRouteToPharmacy(): void {
    const body = {
      requestId: this.request.id,
      pspPharmacyId: this.selectedPharmacy.id
    };
    this.medicalRequestService.routeToPharmacy(body).subscribe(
      (res) => {
        window.history.back();
        showNotification('success', 'Patient Request is now in progress', this.toastr);
      }
    );
  }

}
